export default __webpack_public_path__ + "static/media/Mercenary's Straps of the Yellow Spring.6b2193a5.jpg";